import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { Dashboard } from '../pages/Dashboard';
import { LoginPage, RegisterPage, ForgotPasswordPage } from '../pages/auth';
import { Projects } from '../pages/Projects';
import { ProjectView } from '../pages/ProjectView';
import { SheetView } from '../pages/SheetView';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { AppShell } from '../components/layout';
import { SignInAndUpCallback } from 'supertokens-auth-react/recipe/thirdparty/prebuiltui';

// Lazy load non-critical routes
const Settings = lazy(() => import('../pages/Settings').then(m => ({ default: m.Settings })));
const BillingPage = lazy(() => import('../pages/settings/BillingPage'));

function LazyFallback() {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="h-5 w-5 animate-spin rounded-full border-2 border-primary border-t-transparent" />
    </div>
  );
}

export function AppRoutes() {
  return (
    <Routes>
      {/* Auth routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/callback/:providerId" element={<SignInAndUpCallback />} />

      {/* Protected routes with AppShell layout */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppShell>
              <Dashboard />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects"
        element={
          <ProtectedRoute>
            <AppShell>
              <Projects />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects/:projectId"
        element={
          <ProtectedRoute>
            <AppShell>
              <ProjectView />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects/:projectId/sheets/:sheetId"
        element={
          <ProtectedRoute>
            <AppShell>
              <SheetView />
            </AppShell>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <AppShell>
              <Suspense fallback={<LazyFallback />}>
                <Settings />
              </Suspense>
            </AppShell>
          </ProtectedRoute>
        }
      />

      <Route
        path="/settings/billing"
        element={
          <ProtectedRoute>
            <AppShell>
              <Suspense fallback={<LazyFallback />}>
                <BillingPage />
              </Suspense>
            </AppShell>
          </ProtectedRoute>
        }
      />

      {/* Fallback route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
